import { render, staticRenderFns } from "./inquiry-expense-modal.vue?vue&type=template&id=4b5e8937&scoped=true&"
import script from "./inquiry-expense-modal.vue?vue&type=script&lang=js&"
export * from "./inquiry-expense-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5e8937",
  null
  
)

export default component.exports